import { render, staticRenderFns } from "./omt-slider.vue?vue&type=template&id=d6b936a0&scoped=true&"
import script from "./omt-slider.vue?vue&type=script&lang=js&"
export * from "./omt-slider.vue?vue&type=script&lang=js&"
import style0 from "./omt-slider.vue?vue&type=style&index=0&id=d6b936a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b936a0",
  null
  
)

export default component.exports